<script lang="ts" setup>
import { TaxonomyTermToccoCountry, TermsDocument } from '~/api/graphql/generated'
import type { TermsQueryVariables } from '~/api/graphql/generated'
import { useI18n } from 'vue-i18n'

import { Option } from '~/components/atoms/forms/select/Select.vue'
import { useTypedAsyncQuery } from '~/lib/utils/graphqlDocument'

const { t } = useI18n()

withDefaults(
  defineProps<{
    addressRequired?: boolean
  }>(),
  {
    addressRequired: true,
  },
)

const { languageCODE } = useLocale()
const termsVariables: TermsQueryVariables = {
  limit: 250,
  vocabulary: 'tocco_country',
  language: languageCODE.value,
}
const { data: termsData } = await useTypedAsyncQuery(TermsDocument, termsVariables)

const options = reactive({
  entities: (termsData.value?.taxonomyTermQuery?.entities as TaxonomyTermToccoCountry[])?.map((entity): Option => ({
    label: entity?.name ?? '',
    value: entity?.fieldExternalId ?? '',
  })),
})
</script>

<template>
  <div class="form-section--2-cols">
    <Input
      id="address-street-address"
      name="street_address"
      :label="t('tocco.registration.address.streetAddress')"
      :required="addressRequired"
    />
    <Input id="address-po-box" name="po_box" :label="t('tocco.registration.address.poBox')" :required="false" />
  </div>

  <div class="form-section--30-70-cols">
    <Input
      id="address-postal-code"
      type="text"
      name="postal_code"
      :label="t('tocco.registration.address.postalCode')"
      :validation="'number|length:0,10'"
      :required="addressRequired"
    />
    <Input id="address-city" name="city" :label="t('tocco.registration.address.city')" :required="addressRequired" />
  </div>

  <Select
    id="address-country"
    name="country"
    :label="t('tocco.registration.address.country')"
    :required="addressRequired"
    :options="options.entities"
  />
</template>
